import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import Hero from './HeroSection/Hero';
import useConfigs from '../hooks/useConfigs';
import CustomInput from './Inputs/CustomInput';
import SubmitButton from './Buttons/SubmitButton';
import CustomTextarea from './Inputs/CustomTextarea';
import { LineaAtencion } from './UI/LineaAtencion';
import { Peticiones } from './UI/Peticiones';
import { contactenos } from '../services/parameter.service';
import AlertDialog from './Alertas/AlertDialog';
import AlertError from './Alertas/AlertError';
import useThemes from '../hooks/useThemes';
import { useApi } from '../hooks/useApi';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX, faLocationDot, faEnvelope, faUser, faPhone, faMessage } from '@fortawesome/free-solid-svg-icons';
import {
  faComments,
} from '@fortawesome/free-regular-svg-icons';
import { 
  faWhatsapp, faTiktok, faTwitter, faInstagram,
  faLinkedin, faFacebook, faTwitch, faYoutube,
} from '@fortawesome/free-brands-svg-icons';

library.add(
  faWhatsapp, faTiktok, faTwitter, faInstagram,
  faLinkedin, faFacebook, faTwitch, faYoutube, faX, faLocationDot, faEnvelope, faUser, faPhone, faComments,
  faMessage,
  );

const schema = yup
  .object({
    nombres: yup.string().required('Los nombres son requeridos'),
    apellidos: yup.string().required('Los apellidos son requeridos'),
    telefono: yup
      .number()
      .typeError('El teléfono debe ser un número')
      .positive('El número de teléfono debe ser positivo')
      .integer('Ingrese solo números enteros')
      .min(1000000, 'Ingrese mínimo 7 dígitos')
      .required('El teléfono es requerido'),
    correoElectronico: yup
      .string()
      .email('Ingrese un correo válido')
      .required('El correo electrónico es requerido'),
    asunto: yup.string().required('El asunto es requerido'),
    comentario: yup.string().required('El comentario es requerido'),
  })
  .required();

export const PageContactFamedic = () => {
  window.scroll(0, 0)
  const { fontSizeMultiplier } = useConfigs();
  const { contacto, getContacto } = useApi();
  const { data } = contacto;
  const history = useHistory();
  const { backgroundWhite, colorSecundario, colorPrincipal } = useThemes();

  const { handleSubmit, control, reset } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(schema),
  });

  const [isLoading, setIsLoading] = useState(false);
  const [errorProps, setErrorProps] = useState(null);
  const [alertProps, setAlertProps] = useState(null);

  const onSubmit = async (data) => {
    setIsLoading(true);

    try {
      const response = await contactenos({
        ...data,
        telefono: data.telefono.toString(),
      });
      setIsLoading(false);

      if (response.data.code === 201 || response.data.code === 200) {
        setAlertProps({
          isOpen: true,
          onClose: () => setAlertProps({ isOpen: false }),
          primaryOnClick: () => history.push('/'),
          secondaryOnClick: () => {
            reset({
              nombres: '',
              apellidos: '',
              telefono: '',
              correoElectronico: '',
              asunto: '',
              comentario: '',
            });

            setAlertProps({ isOpen: false });
          },
        });
      }
    } catch (error) {
      setIsLoading(false);

      setErrorProps({
        isOpen: true,
        contenido: error.message,
        onClose: () => setErrorProps({ isOpen: false }),
        primaryOnClick: () => history.push('/'),
        secondaryOnClick: () => setErrorProps({ isOpen: false }),
      });
    }
  };

  useEffect(() => {
    getContacto();
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container
      fontsizemultiplier={fontSizeMultiplier}
      background={backgroundWhite}
      color={colorPrincipal}
      colorsecundario={colorSecundario}
    >
      <Hero
        color={backgroundWhite}
        imgSrc='img/Servicios/consultas-quejas-reclamos.JPG'
        title='Contáctanos'
      />

      <AlertDialog {...alertProps} />
      <AlertError {...errorProps} />

      <div className='info-container'>
        <div className='btn-container'>

        {
          data.dataAllContact.map( (item, index) => (
            item.rutaOpcion.includes("http") ?
            <a
            className='contact-btn'
            key={item.id}
            href={ item.rutaOpcion.includes("http") ? item.rutaOpcion : `mailto:${item.nombreOpcion}`}
            target='_blank'
            rel='noreferrer'
            >
              <FontAwesomeIcon
                  icon={item.icono}
                  color={colorSecundario}
                  size='xl'
                  className='iconoFontAwesome'
                />
              <p>{item.nombreOpcion}</p>
            </a>
            :  item.rutaOpcion.includes('lineaatencion') ? (
              ''
            ) 
            :
            <div className='contact-btn' key={item.id} onClick={() => history.push(item.rutaOpcion)}>
              <FontAwesomeIcon
                  icon={item.icono}
                  color={colorSecundario}
                  size='xl'
                  className='iconoFontAwesome'
                />
              <p>{item.nombreOpcion}</p>
            </div>
          ))
        }



        </div>

        <h2 className='form-title'>Escríbenos</h2>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className='input-container'>
            <Controller
              name='nombres'
              control={control}
              render={({
                field: { value, onBlur, onChange },
                fieldState: { error },
              }) => (
                <CustomInput
                  value={value}
                  onChange={onChange}
                  onBlut={onBlur}
                  label='Nombres *'
                  width='49%'
                  error={error}
                />
              )}
            />

            <Controller
              name='apellidos'
              control={control}
              render={({
                field: { value, onBlur, onChange },
                fieldState: { error },
              }) => (
                <CustomInput
                  value={value}
                  onChange={onChange}
                  onBlut={onBlur}
                  label='Apellidos *'
                  width='49%'
                  error={error}
                />
              )}
            />
          </div>

          <div className='input-container'>
            <Controller
              name='telefono'
              control={control}
              render={({
                field: { value, onBlur, onChange },
                fieldState: { error },
              }) => (
                <CustomInput
                  value={value}
                  onChange={onChange}
                  onBlut={onBlur}
                  label='teléfono *'
                  width='49%'
                  error={error}
                />
              )}
            />

            <Controller
              name='correoElectronico'
              control={control}
              render={({
                field: { value, onBlur, onChange },
                fieldState: { error },
              }) => (
                <CustomInput
                  value={value}
                  onChange={onChange}
                  onBlut={onBlur}
                  label='correo electrónico *'
                  width='49%'
                  error={error}
                  type='email'
                />
              )}
            />
          </div>

          <div className='input-container'>
            <Controller
              name='asunto'
              control={control}
              render={({
                field: { value, onBlur, onChange },
                fieldState: { error },
              }) => (
                <CustomInput
                  value={value}
                  onChange={onChange}
                  onBlut={onBlur}
                  label='Asunto *'
                  error={error}
                />
              )}
            />
          </div>

          <div className='input-container'>
            <Controller
              name='comentario'
              control={control}
              render={({
                field: { value, onBlur, onChange },
                fieldState: { error },
              }) => (
                <CustomTextarea
                  value={value}
                  onChange={onChange}
                  onBlut={onBlur}
                  label='Comentario *'
                  error={error}
                />
              )}
            />
          </div>

          <SubmitButton label='Enviar' isLoading={isLoading} />
        </form>
        <LineaAtencion />
        <Peticiones />
      </div>
    </Container>
  );
};

const Container = styled.div`
  padding-bottom: 3rem;
  background-color: ${(props) => props.background};

  .info-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 5vh;
  }
  .iconoFontAwesome{
    font-size: 35px;
    padding: 0.5rem;
  }

  .btn-container {
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr 1fr;
    width: 50vw;
    margin-top: 5vh;
    margin-bottom: 6rem;

    @media (max-width: 1023px) {
      width: 90vw;
      gap: 2rem;
      grid-template-columns: 1fr;
    }
  }

  .contact-btn {
    display: flex;
    align-items: center;
    border-radius: 4rem;
    overflow: hidden;
    padding: 1rem 2rem;
    cursor: pointer;
    border: 2px solid ${(props) => props.colorsecundario};
    background-color: transparent;

    &:hover {
      filter: brightness(1.1);
    }

    img {
      width: ${(props) => 60 * props.fontsizemultiplier};
    }

    p {
      font-size: ${(props) => 25 * props.fontsizemultiplier};
      font-weight: 700;
      margin: auto 0rem;
      color: ${(props) => props.colorsecundario};
    }
  }

  .form-title {
    font-size: ${(props) => 70 * props.fontsizemultiplier};
    color: ${(props) => props.color};

    @media (max-width: 1023px) {
      font-size: ${(props) => 50 * props.fontsizemultiplier};
    }
  }

  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.background};
  }

  .input-container {
    display: flex;
    justify-content: space-between;
    width: 50vw;

    @media (max-width: 1023px) {
      flex-wrap: wrap;
      width: 90vw;
    }
  }
`;
